export class LoadLookupData {
  static readonly type = '[Lookup] Load Lookup';
}
